<div class="container">
    <div class="error-container">
        <h1>404 - Page not found</h1>
    </div>
</div>